import { render, staticRenderFns } from "./LocaleMenuItem.vue?vue&type=template&id=666af8a4&scoped=true"
import script from "./LocaleMenuItem.vue?vue&type=script&lang=js"
export * from "./LocaleMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666af8a4",
  null
  
)

export default component.exports